import { Stack, Breakpoint } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { FC, useState, useEffect, useMemo } from 'react';
import { Linkable } from '@/components/blocks/Linkable';
import { useLocalization } from '@/data/Localization';
import { headerLinkSX } from '@/components/content/Header/styles/link';
import { useUser } from '@/data/User';
import { ACCOUNT_QUERY_TABS } from '@/components/content/Account';

type Props = {
	mobileBreakpoint: Breakpoint;
};

export const HeaderFavorite: FC<Props> = () => {
	const RouteLocal = useLocalization('Routes');
	const { user } = useUser();
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

	useEffect(() => {
		setIsLoggedIn(() => user?.isLoggedIn ?? false);
	}, [user]);

	const { route } = useMemo(() => {
		const showMyAccount = isLoggedIn;
		const baseRoute = showMyAccount
			? `/${RouteLocal.Account.route.t()}`
			: `/${RouteLocal.Login.route.t()}`;

		return {
			showMyAccount,
			route: {
				pathname: baseRoute,
				query: showMyAccount
					? { tab: ACCOUNT_QUERY_TABS.FAVORITES }
					: { origin: 'go_to_favorites' },
			},
		};
	}, [RouteLocal, isLoggedIn]);

	return (
		<Linkable href={route} sx={headerLinkSX}>
			<Stack alignItems="center">
				<FavoriteIcon sx={{ width: '20px' }} />
			</Stack>
		</Linkable>
	);
};
